var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSplitScreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 5.25V18.75H3V5.25H7.5ZM7.5 3.75H3C2.60218 3.75 2.22064 3.90804 1.93934 4.18934C1.65804 4.47064 1.5 4.85218 1.5 5.25V18.75C1.5 19.1478 1.65804 19.5294 1.93934 19.8107C2.22064 20.092 2.60218 20.25 3 20.25H7.5C7.89782 20.25 8.27936 20.092 8.56066 19.8107C8.84196 19.5294 9 19.1478 9 18.75V5.25C9 4.85218 8.84196 4.47064 8.56066 4.18934C8.27936 3.90804 7.89782 3.75 7.5 3.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 5.25V18.75H16.5V5.25H21ZM21 3.75H16.5C16.1022 3.75 15.7206 3.90804 15.4393 4.18934C15.158 4.47064 15 4.85218 15 5.25V18.75C15 19.1478 15.158 19.5294 15.4393 19.8107C15.7206 20.092 16.1022 20.25 16.5 20.25H21C21.3978 20.25 21.7794 20.092 22.0607 19.8107C22.342 19.5294 22.5 19.1478 22.5 18.75V5.25C22.5 4.85218 22.342 4.47064 22.0607 4.18934C21.7794 3.90804 21.3978 3.75 21 3.75Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 3H11.25V21H12.75V3Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplitScreen);
export default __webpack_public_path__ + "static/media/Split-screen.89f7e392cd218704bf48a5025680112c.svg";
export { ForwardRef as ReactComponent };